<template>
<Row class="top-tools-ct" type="flex" align="middle">
    <router-link class="back-btn" :to="{'name': 'Trade'}">Back</router-link>
    <!-- <Dropdown class="choosen-dropdown dropdown-ct">
      <div class="bytetrade-icon bytetrade-china"></div>
      <a class="dropdown-btn" href="javascript:void(0)">
        简体中文
        <Icon type="md-arrow-dropdown"></Icon>
      </a>
      <DropdownMenu class="dropdown-menu" slot="list">
        <DropdownItem class="dropdown-item">
          <div class="bytetrade-icon bytetrade-en"></div>
          <div>English</div>
        </DropdownItem>
        <DropdownItem class="dropdown-item" selected>
          <div class="bytetrade-icon bytetrade-china"></div>
          <div>简体中文</div>
        </DropdownItem>
        <DropdownItem class="dropdown-item">
          <div class="bytetrade-icon bytetrade-jp"></div>
          <div>jp</div>
        </DropdownItem>
        <DropdownItem class="dropdown-item">
          <div class="bytetrade-icon bytetrade-tu"></div>
          <div>土耳其</div>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown> -->
</Row>
</template>

<script>
export default {
    name: 'TopTools',
};
</script>

<style lang="less">
@import "../../../static/style/color.less";
@import "../../../static/style/preset.less";

.top-tools-ct {
    position: absolute;
    top: 20px;
    right: 50px;

    .back-btn {
        font-size: @font-size-14;
        color: @light-grey-1;
        margin-right: 20px;
    }

    .choosen-dropdown {
        height: 100%;

        .ivu-dropdown-rel {
            height: 100%;
            display: flex;
            align-items: center;
        }

        .dropdown-btn {
            height: 100%;
            line-height: 46px;
            color: @font-black;
            font-size: @font-size-12;
        }

        &.dropdown-ct {
            .bytetrade-icon {
                width: 21px;
                height: 15px;
                margin-right: 10px;

                &.bytetrade-zhCN {
                    background-image: url("../../assets/image/cn.png");
                    background-size: cover;
                }

                &.bytetrade-en {
                    background-image: url("../../assets/image/en.png");
                    background-size: cover;
                }

                &.bytetrade-jp {
                    background-image: url("../../assets/image/jp.png");
                    background-size: cover;
                }

                &.bytetrade-tu {
                    background-image: url("../../assets/image/tu.png");
                    background-size: cover;
                }
            }

            .ivu-select-dropdown {

                //background-color: @dark-blue-1;
                .dropdown-menu {
                    .dropdown-item {
                        display: flex;
                        align-items: center;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ruc/TopTools.vue